var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPath = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8233 15.0709C45.3257 12.5585 47.5317 10.75 50.0939 10.75H78.906C81.4681 10.75 83.6741 12.5585 84.1766 15.0709L84.3874 16.125H91.375C100.281 16.125 107.5 23.3444 107.5 32.25V102.125C107.5 111.031 100.281 118.25 91.375 118.25H37.625C28.7194 118.25 21.5 111.031 21.5 102.125V32.25C21.5 23.3444 28.7194 16.125 37.625 16.125H44.6124L44.8233 15.0709ZM53.4253 26.875L54.5003 21.5H74.4995L75.5745 26.875H53.4253ZM86.5374 26.875L87.4016 31.1959C88.0668 34.5219 85.5229 37.625 82.131 37.625H46.8689C43.477 37.625 40.9331 34.5219 41.5983 31.1959L42.4624 26.875H37.625C34.6565 26.875 32.25 29.2815 32.25 32.25V102.125C32.25 105.094 34.6565 107.5 37.625 107.5H91.375C94.3435 107.5 96.75 105.094 96.75 102.125V32.25C96.75 29.2815 94.3435 26.875 91.375 26.875H86.5374Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.758 52.6055C80.7356 51.6184 82.0673 51.0625 83.4574 51.0625C84.8479 51.0625 86.18 51.6188 87.1577 52.6065C89.1993 54.6564 89.1974 57.9423 87.1521 59.9899L59.9969 87.1492C57.9479 89.1994 54.6305 89.2 52.5819 87.1492L41.8479 76.4034C39.8026 74.3559 39.8007 71.07 41.8422 69.0201C42.8199 68.0324 44.152 67.476 45.5426 67.476C46.9327 67.476 48.2644 68.032 49.2421 69.0191L56.3022 76.087L79.758 52.6055Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPath);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/path.d517ee8e70ccfff50fe120718f5feddc.svg";